namespace Areas {
    "use strict";

    export function lookupActiveTemplate(getItemText: (any) => string) {
        return (itemData: any, itemIndex: any, itemElement: any) => {

            const text = getItemText(itemData);

            if (itemData.isActive) {
                itemElement.append("<div><span class=\"collookupspan\">" + text + "</span></div>");
            } else {
                itemElement.append("<div class=\"inactive\"><span class=\"collookupspan\">" + text + "</span>" +
                    " - Disabled<div>").closest(".dx-list-item").css("pointer-events", "none");
            }
        }
    }
}


        
